<template>
  <div class="">
    <h2 class="font-nutino font-bold text-[24px] lg:font-extrabold lg:text-[40px] text-center">{{ t('b2b.wellbeing.numbers-lang.title') }}</h2>
    <div class="flex flex-col lg:flex-row mt-[24px] lg:mt-[48px] gap-x-[48px] gap-y-[12px] items-stretch">
      <div class="flex flex-col gap-y-[12px] lg:gap-y-[48px] ">
        <Card shadow bgColor>
          <div class="py-[30px] px-[10px] md:py-[60px] md:px-[34px]">
            <p class="font-nutino font-bold text-[15px] lg:text-[39px] leading-[1.3]">{{ t('b2b.wellbeing.numbers-lang.card.1') }}</p>
          </div>
        </Card>
        <Card shadow bgColor>
          <div class="py-[30px] px-[10px] md:py-[60px] md:px-[34px]">
            <p class="font-nutino font-bold text-[15px] lg:text-[39px] leading-[1.3]">{{ t('b2b.wellbeing.numbers-lang.card.2') }}</p>
          </div>
        </Card>
      </div>
      <div class="">
        <Card shadow bgColor>
          <div class="md:min-w-[519px] p-[10px] h-full flex items-center justify-center">
            <NuxtImg src="/wellbeing/charts/3.svg" class="md:w-[364px] md:h-[364px] w-[250px] h-[250px]"/>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Card from '../ui/Card.vue';

const { t } = useI18n();

</script>

